import React from "react";
import { View } from "@react-pdf/renderer";
import { CommonStyles } from "../pdf-styles";

export const Footer = ({ children }) => <View fixed style={CommonStyles.footer}>
  {children}
</View>

